/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Feedback_Send_FailedInputs */

const en_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That did not send. Try again, or email support@getanyapi.com.`)
};

const zh_hans1_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送失败。请重试，或发邮件至 support@getanyapi.com。`)
};

const pt_br2_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi enviado. Tente de novo ou escreva para support@getanyapi.com.`)
};

const es_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar. Inténtalo de nuevo o escribe a support@getanyapi.com.`)
};

const fr_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’envoi a échoué. Réessayez, ou écrivez à support@getanyapi.com.`)
};

const de_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das wurde nicht gesendet. Versuch es erneut oder schreib an support@getanyapi.com.`)
};

const ru_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не отправилось. Попробуйте ещё раз или напишите на support@getanyapi.com.`)
};

const it_phase2_fix_feedback_send_failed = /** @type {(inputs: Phase2_Fix_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio non riuscito. Riprova, oppure scrivi a support@getanyapi.com.`)
};

/**
* | output |
* | --- |
* | "That did not send. Try again, or email support@getanyapi.com." |
*
* @param {Phase2_Fix_Feedback_Send_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_feedback_send_failed = /** @type {((inputs?: Phase2_Fix_Feedback_Send_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Feedback_Send_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_feedback_send_failed(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_feedback_send_failed(inputs)
	if (locale === "es") return es_phase2_fix_feedback_send_failed(inputs)
	if (locale === "fr") return fr_phase2_fix_feedback_send_failed(inputs)
	if (locale === "de") return de_phase2_fix_feedback_send_failed(inputs)
	if (locale === "ru") return ru_phase2_fix_feedback_send_failed(inputs)
	if (locale === "it") return it_phase2_fix_feedback_send_failed(inputs)
	return en_phase2_fix_feedback_send_failed(inputs)
});